define("shared/utils/object-methods/stack-object-array-values", ["exports", "@ember/array", "lodash"], function (_exports, _array, _lodash) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/array",0,"lodash"eaimeta@70e063a35619d71f
  /**
   * @module Utils
   */

  /**
   * @class stackObjectArrayValues
   * @extends Utils
   */
  /** Customizer concatenates array values and is invoked to produce the merged values of the destination and source properties
   *
   * @method stackObjectArrayValues
   * @param {Object} baseObj The destination object
   * @param {...Objects} objs The source objects
   *
   * @returns {Object} the merged object of the destination and source properties
   */
  const stackObjectArrayValues = (baseObj, objs) => (0, _lodash.mergeWith)(baseObj, ...objs, (objValue, srcValue) => (0, _array.isArray)(objValue) ? objValue.concat(srcValue) : null);
  var _default = _exports.default = stackObjectArrayValues;
});